import { PrimaryButton } from '@client/new/components/button';
import { PATHS } from '@client/routes';
import { useState } from 'react';
import { Link } from 'react-router';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Divider } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import programIcon from '/static/images/program-icon.svg';
import collectionIcon from '/static/images/collection-icon.svg';
import workoutIcon from '/static/images/workout-icon.svg';
import classIcon from '/static/images/class-icon.svg';

type Props = {
  selectedProgramId: number | null;
  influencerId: number;
};

export function CreateActionsDropdown({
  selectedProgramId,
  influencerId,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <PrimaryButton
        aria-controls={open ? 'create-actions-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <span className="mr-2">Create</span>
        <FontAwesomeIcon icon={faChevronDown} />
      </PrimaryButton>
      <Menu
        id="create-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'create-button',
        }}
      >
        <MenuItem onClick={handleClose}>
          <Link
            data-testid="create-class"
            to={PATHS.CLASS_EDIT({
              influencerId,
              workoutId: 0,
              programId: selectedProgramId,
            })}
            className="flex gap-1.5"
          >
            <img src={classIcon} alt="Class icon" />
            <span className="title">Class</span>
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link
            data-testid="create-workout"
            to={PATHS.WORKOUT_EDIT({
              influencerId,
              workoutId: 0,
              programId: selectedProgramId,
            })}
            className="flex gap-1.5"
          >
            <img src={workoutIcon} alt="Workout icon" />
            <span className="title">Workout</span>
          </Link>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleClose}>
          <Link
            data-testid="create-program"
            to={`/admin/${influencerId}/new-program`}
            className="flex gap-1.5"
          >
            <img src={programIcon} alt="Program icon" />
            <span className="title">Program</span>
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link
            data-testid="create-category"
            to={`/admin/${influencerId}/new-category`}
            className="flex gap-1.5"
          >
            <img src={collectionIcon} alt="Category icon" />
            <span className="title">Category</span>
          </Link>{' '}
        </MenuItem>
      </Menu>
    </div>
  );
}
